import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_GREY,
    mapProp: 'kmMap',
    name: '知识库',
    textProp: 'kmTitle',
    type: 'KM',
}
